<template>
  <div class="containers">
    <h2 class="ui header" v-if="header">
      <i class="cubes grey icon" />
      <sui-header-content>{{header}}</sui-header-content>
    </h2>
    <transition-group class="ui cards entities" name="card" v-if="containers.length">
      <sui-card class="card-item" key="new" v-if="service">
        <sui-button-group class="fluid content" basic vertical size="huge">
          <sui-button icon="blue sitemap" label-position="left" :disabled="isScaleDisabled" @click.prevent="$modals.scaleService.open(service)" data-goal="CONTAINERS_CARDS_SCALE_SERVICE">Service scaling</sui-button>
          <sui-button icon="green scale balance" label-position="left" :disabled="isBalanceDisabled" @click.prevent="createBalancer()" data-goal="CONTAINERS_CARDS_BALANCE_SERVICE">Load balancing</sui-button>
          <sui-button icon="orange directions" label-position="left" :disabled="isLogProviderDisabled" @click.prevent="openLogProviderSelector()" data-goal="CONTAINERS_CARDS_OPEN_LOGPROVIDER">Log redirection</sui-button>
          <sui-button icon="terminal" label-position="left" :disabled="isExecuteDisabled" @click.prevent="$modals.executeCommands.open(service)" data-goal="CONTAINERS_CARDS_EXECUTE_SERVICE">Execute command</sui-button>
        </sui-button-group>
      </sui-card>
      <ContainerCard :container="container" v-for="container in containers" :key="container.id" />
    </transition-group>
    <sui-segment class="empty" padded v-if="!containers.length">
      There are no containers on the host<span v-if="!member.isOwner"> or you don't have permissions to see them</span>.
    </sui-segment>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import uniq from 'lodash/uniq'
  import ContainerCard from './Container'
  import api from '@/api'
  import objects from '@/objects'

  export default {
    name: 'ContainerCards',
    components: {
      ContainerCard,
    },
    props: {
      header: {
        type: String,
        required: false,
        default: 'Containers',
      },
      containers: {
        type: Array,
        required: false,
        default() {
          return this.$store.getters.containers
        },
      },
    },
    computed: {
      ...mapGetters(['access', 'actionsById', 'member', 'providersById', 'servicesById']),
      actions() {
        return this.service ? this.actionsById[this.service.id] : {}
      },
      service() {
        const services = uniq(this.containers.map(container => container.service))
        return services.length === 1 ? this.servicesById[services[0]] : null
      },
      inProgress() {
        return this.service && this.service._inProgress
      },
      isScaleDisabled() {
        return !this.service.constructor.methods.scale || this.service._isOffline || this.inProgress || !this.actions.serviceScale
      },
      isBalanceDisabled() {
        const hasUnsupportedProtocols = this.service.ports.some(port => !objects.ServiceHAProxy.fields.services.servicePortProtocols.includes(port.protocol))
        const hasMethod = this.service.constructor.methods.balance
        const hasAccess = this.access.serviceCreate
        return hasUnsupportedProtocols || !hasMethod || !hasAccess
      },
      isLogProviderDisabled() {
        return !this.access.serviceUpdate
      },
      isExecuteDisabled() {
        return !this.service.constructor.methods.execute || !this.service._isDeployed || this.inProgress || !this.access.serviceTerminal
      },
      logProvider() {
        return this.providersById[this.service.logProvider]
      },
    },
    watch: {
      containers(newContainers, oldContainers) {
        if (newContainers.map(container => container.id).join() !== oldContainers.map(container => container.id).join()) {
          oldContainers.forEach(container => {
            api.subscriptions.containerStats[container.id] = api.subscriptions.containerStats[container.id] - 1
          })
          newContainers.forEach(container => {
            api.subscriptions.containerStats[container.id] = api.subscriptions.containerStats[container.id] ? api.subscriptions.containerStats[container.id] + 1 : 1
          })
          api.subscriptions.updateContainerStats()
        }
      },
    },
    methods: {
      createBalancer() {
        const haproxy = objects.Service.create({type: 'haproxy'})
        const mode = haproxy.getServiceConfigMode(this.service)
        haproxy.project = this.service.project
        haproxy.name = `${this.service.name}-lb`
        haproxy.services = [haproxy.getServiceConfig(this.service)]
        if (mode === 'tcp') {
          haproxy.ports = this.service.ports.filter(port => port.protocol === 'TCP')
        }
        this.$modals.createService.open(haproxy)
      },
      openLogProviderSelector() {
        const service = this.service._clone
        service.upsert = service.updateLogProvider
        this.$modals.updateService.open(service, 'updatingLogProvider')
      },
    },
    mounted() {
      this.containers.forEach(container => {
        api.subscriptions.containerStats[container.id] = api.subscriptions.containerStats[container.id] ? api.subscriptions.containerStats[container.id] + 1 : 1
      })
      api.subscriptions.updateContainerStats()
    },
    destroyed() {
      this.containers.forEach(container => {
        api.subscriptions.containerStats[container.id] = api.subscriptions.containerStats[container.id] - 1
      })
      api.subscriptions.updateContainerStats()
    },
  }
</script>

<style scoped>
  .empty { font-size: 1.3em!important; }
  .ui.card > .content { display: flex; flex-grow: 1!important; padding: 0!important; }
  .ui.buttons { margin: 0!important; width: auto!important; }
  .ui.buttons .ui.button { flex: 1; min-height: 2.8em; justify-content: flex-start!important; align-items: center!important; padding-left: 4em!important; white-space: nowrap; }
  .ui.buttons .ui.button:hover { background-color: #eee; box-shadow: none!important; }
  .ui.buttons .ui.button >>> .icon { display: flex; align-items: center; font-size: 1.3em; }
</style>
